
<label class="Checkbox" :class="{ 'isLarge': large }">
  <input :checked="value" class="Checkbox__input" :disabled="disabled" type="checkbox" @change="change" />
  <span class="Checkbox__virtualInput"></span>
  <span v-if="$slots.default" class="Checkbox__label">
    <slot />
  </span>
</label>
